import React from 'react';
import BrandingFooter from './BrandingFooter';
import TeamCell from './TeamCell';

export default function PlayerTable({
  showBranding = false,
  competitionLabel = 'Premier League',
  subtitle = '',
  rows = [],
  columns = [],
  emptyMessage = 'No data available.',
  rowKey = (r) => `${r.rank}-${r.player}`,
}) {
  const header = subtitle ? `${competitionLabel} — ${subtitle}` : competitionLabel;

  return (
    <div style={{ background: 'var(--sw-bg)', color: 'var(--sw-text)' }}>
      <div
        className="px-4 py-2 text-xs font-bold uppercase tracking-wide border-b"
        style={{ borderColor: 'var(--sw-border)', color: 'var(--sw-muted)' }}
      >
        {header}
      </div>
      <div className="p-3">
        {rows.length ? (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase" style={{ color: 'var(--sw-muted)' }}>
                {columns.map((col) => (
                  <th
                    key={col.key}
                    className={`p-2 ${col.align === 'right' ? 'text-right' : ''} ${col.width || ''}`}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={rowKey(r)} style={{ borderTop: '1px solid var(--sw-border)' }}>
                  {columns.map((col) => (
                    <td
                      key={col.key}
                      className={`p-2 ${col.align === 'right' ? 'text-right tabular-nums' : ''} ${
                        col.bold ? 'font-bold' : col.muted ? 'text-xs' : 'font-medium'
                      }`}
                      style={col.muted ? { color: 'var(--sw-muted)' } : undefined}
                    >
                      {col.render ? (
                        col.render(r)
                      ) : col.key === 'team' ? (
                        <TeamCell row={r} />
                      ) : (
                        r[col.key]
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-center text-xs py-6" style={{ color: 'var(--sw-muted)' }}>
            {emptyMessage}
          </p>
        )}
      </div>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
